import { FOOD_TABS_MAPPING } from "../common/commonConstant";
import config from "../config";

export class FoodDetail {
  constructor(data) {
    if (data) {
      this.id = data._id || '';
      this.name = data.name || '';
      this.foodImage = data.image || '';
      this.foodImageUrl = this.foodImage ? `${config.S3_URL}${this.foodImage}` : '';
      this.tagImage = data?.category?.tagImage ? `${config.S3_URL}${data?.category?.tagImage}` : '';
      this.quantity = data.quantity || 0;
      this.baseQuantity = data.baseQuantity || null;
      this.unit = data.unit || '';
      this.weight = data.weight || 0;
      this.calorie = data.calorie || 0;
      this.carbs = data.carbs || 0;
      this.protein = data.protein || 0;
      this.fat = data.fat || 0;
      this.type = data.type || '';
      this.productCategory = data.productCategory || '';
      this.isFood = this.type ? this.type.toLowerCase() === FOOD_TABS_MAPPING.Food.name.toLowerCase() : this.productCategory ? true : false;
      this.isFavourite = data.isFavourite || false;
      this.favouriteProductId = data.favouriteProductId || null;
    }
  }
}